/**
 * GitHub-style heading anchors for rendered skill markdown: URL fragments match
 * these ids (lowercase, hyphenated, duplicate suffixes -1, -2, ...).
 */

const SLUG_FALLBACK = 'section';

/**
 * Normalizes heading plain text to a base slug (no duplicate suffix).
 */
export function slugifyHeadingPlainText(plainText: string): string {
    const trimmed = plainText.trim().normalize('NFKC');
    const withoutPunct = trimmed.replace(/[^\p{L}\p{N}\s-]/gu, ' ');
    const collapsed = withoutPunct
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    return collapsed || SLUG_FALLBACK;
}

/**
 * Returns a unique id for this heading occurrence within one markdown document.
 */
export function allocateHeadingAnchorId(plainText: string, usedBaseCounts: Map<string, number>): string {
    const base = slugifyHeadingPlainText(plainText);
    const seen = usedBaseCounts.get(base) ?? 0;
    usedBaseCounts.set(base, seen + 1);
    if (seen === 0) {
        return base;
    }
    return `${base}-${seen}`;
}
